import _ from "lodash";
import stringify from "json-stable-stringify";

export function cloneClassInstance(orig, newType = null) {
    if (newType) {
        return Object.assign(new newType(), JSON.parse(JSON.stringify(orig)));
    }
    if (orig == null || typeof orig === "string" || typeof orig === "number") {
        return orig;
    }
    return Object.assign(Object.create(Object.getPrototypeOf(orig)), JSON.parse(JSON.stringify(orig)));
}

export function isPromise(p) {
    if (p && typeof p === 'object' && typeof p.then === 'function') {
        return true;
    }

    return false;
}

export function cloneEntity(rowData) {
    if (rowData?.hasOwnProperty?.('__dataStream__')) {
        let keep = rowData['__dataStream__'];
        rowData['__dataStream__'] = null;
        let rowDataCopy = _.cloneDeep(rowData);
        rowData['__dataStream__'] = keep;
        return rowDataCopy;
    }
    let recoveryValues = [];
    cleanRowData(rowData, recoveryValues);
    let res = _.cloneDeep(rowData);
    recoveryValues.forEach(r => {
        r();
    });
    return res;
}

function cleanRowData(rowData, recoveryValues) {
    if (!rowData) {
        return;
    }
    if (!(rowData instanceof Object)) {
        return;
    }
    // let copy;
    // if (rowData instanceof Array) {
    //     copy = [];
    // } else {
    //     copy = {}
    // }

    for (let key in rowData) {
        if (key === "__formModel__") {
            let oldValue = rowData[key];
            recoveryValues.push(() => {
                rowData[key] = oldValue;
            });
            rowData[key] = null;
            // copy[key] = null;
        } else {
            cleanRowData(rowData[key], recoveryValues);
        }
    }
}


let ignoredKeys = new Set();
ignoredKeys.add("recordMetadata");
ignoredKeys.add("_translations");

function _stringifyCleanup(instance, ignoreFields) {
    if(instance == null){
        return null;
    }
    if(instance instanceof Object){
        let clearCopy = {};
        for (const k of Object.keys(instance).sort()) {
            if(ignoredKeys.has(k)){
                continue;
            }
            if (ignoreFields && ignoreFields.has(k)) {
                continue;
            }
            if(k.startsWith("__")){
                continue;
            }
            if(instance[k] == null){
                continue;
            }
            clearCopy[k] = _stringifyCleanup(instance[k], ignoreFields);
        }
        return clearCopy;
    }
    if(instance instanceof Array){
        let clearCopy = [];
        for(const k in instance){
            clearCopy[k] = _stringifyCleanup(instance[k]);
        }
        return clearCopy;
    }
    return instance;
}

function isJSON(str) {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

export function stringifyForCompare(instance, ignoreFields) {
    if (instance == null) {
        return null;
    }
    if (!isNaN(instance)) {
        return instance.toString();
    }

    if (typeof instance === 'string') {
        if (!isJSON(instance)) {
            return instance;
        }
        return JSON.stringify(JSON.parse(instance));
    }
    let copy = JSON.parse(JSON.stringify(instance));
    copy = _stringifyCleanup(copy, ignoreFields);
    return JSON.stringify(copy);
}
